@if (kindInfo(); as info) {
  <div class="flex flex-wrap items-center gap-1">
    <span
      class="badge h-auto rounded-box gap-1 {{ info.badgeClass }}"
      [class.badge-sm]="small()"
      [title]="info.description">
      <fa-icon [icon]="info.icon"></fa-icon>
      {{ info.title }}
    </span>
    @for (tagId of teamTagIds(); track tagId) {
      <span
        class="badge badge-outline h-auto rounded-box"
        [class.badge-sm]="small()">
        <app-permanent-tag-card
          [tagId]="tagId"
          [small]="small()"
          type="text"></app-permanent-tag-card>
      </span>
    }
  </div>
}
